import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterUser_template} from "./filterUser_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterSingleDate_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template';
import {imagePicker_template} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template';
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterTag_template} from "./filterTag_template";
import {filterArticle_template} from "./filterArticle_template";
import {imagePicker_template_mockup} from '../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template_mockup';

declare var ko: any;

export class productReviewView_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return ` 
                <div class="w-form-body" data-bind="visible: idTemplate() == 5 || idTemplate() == 6 || idTemplate() == 8">
                   <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 5">PRODUCT REVIEW</strong>
                   <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 6">BUYERS GUIDE</strong>
                   <strong class="form-sub-title buyers-guide" data-bind="visible: idTemplate() == 8">COLLECTION</strong>
                   <div class="form-body">
                        <!-- ----------------- -->
                        <!-- Intro text        -->
                        <!-- ----------------- -->
                        
                        <div class="form-group">
                            <label for="article_intro" class="form-label"></label>
                           <p data-bind="html: introText"></p>
                        </div> 
                   </div>
                   <div class="form-body">
                        <div class="form-group">
                            <div class="w-img-article-list">
                                <ul class="img-article-list" data-bind="foreach: reviewItems, attr: { 'data-content': (idTemplate() == 5? 'product-review' : (idTemplate() == 6 ? 'buyers-guide' : (idTemplate() == 8 ? 'collection' :'' ))) }" id="review-item-list">
                                    <li class="img-article-item" data-bind="attr: {id: $index }">
                                        
                                        <div class="w-info">
                                            <span class="label icon " data-bind="class: tagAwardClass, text: award ? award.name : ''"></span>
                                            <div>
                                                <span data-bind="text: ($index() + 1)" class="order"></span>
                                                <span data-bind="text: tag.name" class="title"></span>
                                            </div>
                                        </div>
                                        <div class="ratio-content">
                                            <img data-bind="attr: { src: extraImages.length > 0 ? extraImages[0].url : '/assets/images/placeholder-product.png\' }"  alt="image not found" />
                                        </div>
                                    </li>
                                    
                                </ul>
                            </div>
                        </div>
                   </div>
                </div>
               `;
    }

    protected initPartial():void{

    }

    protected getTemplateName(): string{

        return "productReviewView_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
            idTemplate: ko.observable(null)
            , idStatus: ko.observable(null)
            , reviewItems: ko.observableArray([])
            , introText: ko.observable("")
            , permissions: ko.observableArray(this.initPermissions(['article_edit_takeover', 'article_edit_publishingControl']))
        }
    }


    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
    }

    public getReviewItems() {

        return this.getTemplateViewModel().reviewItems();
    }


    public setIdTemplate(idTemplate): void{

        this.getTemplateViewModel().idTemplate(idTemplate);
    }

    public getIdTemplate(): void{

        return this.getTemplateViewModel().idTemplate();
    }

    public setReviewItems(reviewItems): void{

        if(Array.isArray(reviewItems)){
            reviewItems = reviewItems.sort((a, b) => a.position - b.position);
            for (let i = 0; i < reviewItems.length; i++) {
                reviewItems[i].tagAwardClass = reviewItems[i].award && reviewItems[i].award.name ? 'i-' + reviewItems[i].award.name.replace(' ', '-').toLowerCase() : "";
                reviewItems[i].idTagType = reviewItems[i].tag ? reviewItems[i].tag.idType : 0;
            }
            this.getTemplateViewModel().reviewItems(reviewItems);
        }
    }

    public setIntroText(introText) {

        this.getTemplateViewModel().introText(introText);
    }

    public getIntroText() {

       return this.getTemplateViewModel().introText();
    }


}


// WEBPACK FOOTER //
// ./js/components/templates/productReviewVIew_template..ts